import { render, staticRenderFns } from "./ObservationsPrintReportCoverPage.vue?vue&type=template&id=5f487804&"
import script from "./ObservationsPrintReportCoverPage.vue?vue&type=script&lang=js&"
export * from "./ObservationsPrintReportCoverPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports